/**
 * @file Generic form input component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'text',
    'password',
    'email',
    'url',
    'search',
    'number',
    'hidden',
  ]),
  className: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  size: PropTypes.oneOf(['md', 'sm']),
};

const Input = ({
  id,
  type = 'text',
  className,
  placeholder,
  inputRef,
  size,
  ...props
}) => {
  const classes = classNames({
    'form-control': true,
    'form-control-sm': size === 'sm',
    [className]: !!className,
  });

  return (
    <input
      id={id}
      type={type}
      className={classes}
      placeholder={placeholder}
      ref={inputRef}
      {...props}
    />
  );
};

Input.propTypes = propTypes;

export default Input;
